import type { AccountManagementService } from "@/domain/port/AccountManagementService";
import type { BillingPortalLink } from "../model/AccountBilling";

export class GetBillingPortalLink {
  constructor(private readonly service: AccountManagementService) {}

  execute(returnUrl: string, signal?: AbortSignal): Promise<BillingPortalLink> {
    return this.service.getBillingPortalLink(returnUrl, signal);
  }
}
